import { render, staticRenderFns } from "./BannerMediaUpdateForm.vue?vue&type=template&id=ea456888&"
import script from "./BannerMediaUpdateForm.vue?vue&type=script&lang=js&"
export * from "./BannerMediaUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports